"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputGroups = inputGroups;
// The shape of a downloaded input file. It holds what the calculate tab edits, so the express
// min/max/step triples are not here: a file describes one coil, not one sweep.
const common = [
    {
        groupName: "coil",
        propertyNames: [
            "coilstaggered",
            "coilrows",
            "coildistbtwrows",
            "coiltubesinheight",
            "coiltubelength",
            "coildistbtwtubes",
            "coilcircuitsorpasses",
            "coilcircuits",
            "coilpasses",
            "coilfinspacingorfinsperlength",
            "coilfinspacing",
            "coilfinsperinch",
            "coilconnectionside",
            "coilexchangerflowtype"
        ]
    },
    {
        groupName: "tubes",
        propertyNames: [
            "tubesmaterial",
            "tubesconductivity",
            "tubesthickness",
            "tubesexternaldiameter",
            "tubesfouling"
        ]
    },
    {
        groupName: "fins",
        propertyNames: [
            "finsconductivity",
            "finsthickness",
            "finsfouling"
        ]
    },
    {
        groupName: "inletcollector",
        propertyNames: [
            "inletcollectormaterialtype",
            "inletcollectornrofcollectors",
            "inletcollectorthickness",
            "inletcollectordiameter"
        ]
    },
    {
        groupName: "outletcollector",
        propertyNames: [
            "outletcollectormaterialtype",
            "outletcollectornrofcollectors",
            "outletcollectorthickness",
            "outletcollectordiameter"
        ]
    },
    {
        groupName: "safety",
        propertyNames: ["safetyonsurface", "safetyoncapacity"]
    },
    {
        groupName: "airinputs",
        propertyNames: [
            "airinputstemperature",
            "airinputshumidity",
            "airinputspressure",
            "airinputsairflow"
        ]
    },
    {
        groupName: "coefficients",
        propertyNames: [
            "coefficientsadry",
            "coefficientsbdry",
            "coefficientscdry",
            "coefficientsddry",
            "coefficientsawet",
            "coefficientsbwet",
            "coefficientscwet",
            "coefficientsdwet"
        ]
    },
    {
        groupName: "calculationmethod",
        propertyNames: [
            "calculationmethod",
            "calculationmethodtargettemperature"
        ]
    }
];
const fluid = [
    {
        groupName: "inletheader",
        propertyNames: [
            "inletheadermaterialtype",
            "inletheadernrofheaders",
            "inletheaderthickness",
            "inletheaderdiameter"
        ]
    },
    {
        groupName: "outletheader",
        propertyNames: [
            "outletheadermaterialtype",
            "outletheadernrofheaders",
            "outletheaderthickness",
            "outletheaderdiameter"
        ]
    },
    {
        groupName: "fluidinput",
        propertyNames: [
            "temperaturein",
            "temperatureflow",
            "temperatureout",
            "flow",
            "antifreeze",
            // Decides whether the concentration beside it is by volume or by mass. Exporting the
            // number without its type restored "30%" as the wrong kind of 30%.
            "concentrationtype",
            "concentration"
        ]
    },
    {
        // The box a target-temperature modulation may search in.
        groupName: "fluidconstraints",
        propertyNames: [
            "constraintsminvelocity",
            "constraintsmaxvelocity",
            "constraintsmaxflow",
            "constraintsmaxpressuredrop"
        ]
    }
];
const dx = [
    {
        groupName: "dxinput",
        propertyNames: [
            "evaporationtemp",
            "condensationtemp",
            "subcoolingtemp",
            "superheattemp",
            "freon"
        ]
    }
];
const steam = [
    {
        groupName: "steaminput",
        propertyNames: [
            "pressure",
            "subcoolingtemp",
            "superheattemp"
        ]
    }
];
const bySide = {
    fluid: fluid,
    // DX and condenser describe the same refrigerant side.
    dx: dx,
    condenser: dx,
    steam: steam
};
function inputGroups(coilType) {
    return [...common, ...bySide[coilType]];
}
//# sourceMappingURL=inputs.js.map